'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _wrappers = '(){}"\'';
var _punctuationMark = '.!?:,;';
var _endOfString = '(?=[' + _wrappers + _punctuationMark + ']*)';
var _startOfString = '([\\s' + _wrappers + _punctuationMark + ']*)';
var _noTrailingPuncWrap = '(?:[^\\s]*[^\\s' + _wrappers + _punctuationMark + '])?';
var _domain = '(?:[-a-z0-9]{1,255}\\.)+[a-z]{2,10}';
var _email = '(?:mailto:)?[^\\s' + _wrappers + _punctuationMark.substr(1) + ']+@' + _domain;
var _regularUrl = 'https?://' + _domain + '(?:/' + _noTrailingPuncWrap + ')?';
var _userUrl = _domain + '(?:/' + _noTrailingPuncWrap + ')?';

var email = exports.email = new RegExp('^' + _email + '$', 'i');
var link = exports.link = new RegExp('^((?:' + _email + ')|(?:' + _regularUrl + ')|(?:' + _userUrl + '))$', 'i');
var links = exports.links = new RegExp(_startOfString + '((?:' + _regularUrl + ')|(?:(?:' + _email + ')|(?:' + _userUrl + '))' + _endOfString + ')', 'gi');


/*****************
 ** WEBPACK FOOTER
 ** ./~/linkhunter/lib/regexps.js
 ** module id = 27
 ** module chunks = 0
 **/